import { companyOptions } from "../contexts/CompanyContext";

// "Operação" do cliente (Company.Operation). Espelha CompanyOperations no backend (CVF.Domain/Entities/CompanyOperations.cs).
export const COMPANY_OPERATIONS = [
  "Conta e Ordem",
  "Encomenda",
  "Importação Própria",
  "Exportação",
] as const;

export type CompanyOperation = (typeof COMPANY_OPERATIONS)[number];

// "Empresa"/unidade do cliente (Company.CompanyType): mesmo significado de Process.Type (1–4; 5 = "Todas" fica de fora).
export const COMPANY_TYPE_OPTIONS = companyOptions
  .filter((option) => option.value !== 5)
  .map((option) => ({ value: option.value, label: option.label }));

// Unidades de negócio com cadastro de clientes próprio (1 = CVF Logística, 2 = CVF Distribuidora).
export const LOGISTICS_AND_DISTRIBUTION_TYPES = [1, 2];

export const COMPANY_TYPE_LABELS: Record<number, string> = Object.fromEntries(
  COMPANY_TYPE_OPTIONS.map((option) => [option.value, option.label])
);

export const companyTypeLabel = (companyType?: number | null) =>
  companyType != null ? COMPANY_TYPE_LABELS[companyType] ?? "" : "";

// Campos comerciais do cadastro de empresa (GET/PUT/POST /api/company).
export interface CompanyCommercialProfile {
  companyType?: number | null;
  operation?: CompanyOperation | string | null;
}
